export const getRandomNumber = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);

  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const getNumberFromString = (string: string) => {
  try {
    const numberString = string.match(/\d+/g)?.join('');

    if (!numberString) return 0;

    return Number(numberString);
  } catch (error) {
    return 0;
  }
};

export const numberWithCommas = (value: number, decimal?: number) => {
  const [integer, fraction] = (
    decimal ? value.toFixed(decimal) : value.toString()
  ).split('.');

  return (
    integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
    (fraction ? `.${fraction}` : '')
  );
};

export const decimalFeetToFeetInches = (decimalFeet: number) => {
  const feet = Math.floor(decimalFeet); // Get whole feet
  const inches = Math.round((decimalFeet - feet) * 12); // Convert decimal part to inches

  return `${feet}' ${inches}"`;
};

export const feetInchesToCm = ({
  feet,
  inches,
}: {
  feet: number;
  inches: number;
}) => {
  return feet * 30.48 + inches * 2.54;
};

export const cmToFeetInches = (cm: number) => {
  const totalInches = cm / 2.54;
  const feet = Math.floor(totalInches / 12);
  const inches = Math.round(totalInches % 12);

  return { feet, inches };
};

export const cmToFeetInchesText = (cm: number) => {
  const { feet, inches } = cmToFeetInches(cm);

  return `${feet}' ${inches}"`;
};

export const lbsToKg = (lbs: number) => {
  return +(lbs * 0.453592);
};

export const kgToLbs = (kg: number) => {
  return +(kg / 0.453592);
};

export const getWeight = ({
  weight,
  isUs,
}: {
  weight: number;
  isUs: boolean;
}) => {
  if (isUs) {
    return `${weight.toFixed(0)} lb`;
  }

  return `${lbsToKg(weight).toFixed(1)} kg`;
};
